// extracted by mini-css-extract-plugin
export default {"lds-ripple":"loader_lds-ripple__+xzd3"};